import axios from "axios";
 
//开发外网环境
// axios.defaults.baseURL = "http://192.168.5.3:8002"; 
axios.defaults.baseURL = "http://www.stilloye.com";
// axios.defaults.baseURL = "http://www.acnusik.com";
// axios.defaults.baseURL = "http://www.nicekitchenstore.com";
 
//  测试环境
// axios.defaults.baseURL = "http://192.168.188.27:9000"; //43.143.197.79
//  测试环境
// axios.defaults.baseURL = "http://47.112.122.255:9001"; //43.143.197.79
//  
//线上内网环境
// axios.defaults.baseURL = "http://sixwingsky.com";//43.143.197.79
 
export default axios;



// WEBPACK FOOTER //
// ./src/request/axios.js